export const VISUAL_MAP_SIDEWALL_COLORS_SCALE = [
  { min: 0, max: 2, color: "#ff0100" },
  { min: 2, max: 3.71, color: "#ffff00" },
  { min: 3.71, max: 5.43, color: "#00fe00" },
  { min: 5.43, max: 7.14, color: "#018001" },
  { min: 7.14, max: 8.86, color: "#004001" },
  { min: 8.86, max: 10.57, color: "#0100ff" },
  { min: 10.57, max: 12.29, color: "#00013d" },
  { min: 12.29, max: 14, color: "#ff8000" },
  { min: 14, max: 25, color: "#813f01" },
];

export const VISUAL_MAP_BOTTOM_COLORS_SCALE = [
  { min: 0, max: 4, color: "#ff0100" },
  { min: 4, max: 6, color: "#ffff00" },
  { min: 6, max: 8, color: "#00fe00" },
  { min: 8, max: 10, color: "#018001" },
  { min: 10, max: 12, color: "#004001" },
  { min: 12, max: 14, color: "#0100ff" },
  { min: 14, max: 16, color: "#00013d" },
  { min: 16, max: 18, color: "#ff8000" },
  { min: 18, max: 25, color: "#813f01" },
];
